import { Checkbox } from "antd";
import InputText from "components/inputs/InputText";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import style from "./PromotionRegister.module.css";
import { ToastContainer, toast } from "react-toastify";
import { adminRequester } from "App";
import { validateInput, validateInputs } from "shared/utils/Utils";
import RadioChildren from "components/manager/views/forms/radio/RadioChildren";
import InputPassword from "components/inputs/InputPassword";
import { useTranslation } from "react-i18next";
import { passwordFormat } from "InitialData/regExp";
import CustomButton from "components/buttons/CustomButton";
import RadioGroup from "components/manager/views/forms/radio/RadioGroup";
import NiceModal from "@ebay/nice-modal-react";
import InputNumber from "components/inputs/InputNumber";
import TestDatePicker from "components/inputs/datePicker/TestDatePicker";
import DateChoice from "components/inputs/datePicker/dateChoice/DateChoice";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import FlexGrid from "layouts/flex/FlexGrid";
import ToolTip from "components/tooltip/tooltip";
import DatePicker from "components/inputs/datePicker/DatePicker";

function PromotionRegisterDetail() {
  const inputs = useRef([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [type, setType] = useState("discount");
  const [mixYn, setMixYn] = useState();
  //   const [selectedBrands, setSelectedBrands] = useState([]);
  const [variants, setVariants] = useState([]);
  const [products, setProducts] = useState([]);
  const dateRef = useRef();
  const [startDate, setStartDate] = useState();
  const [endDate, setsEndDate] = useState();

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 10);

  useEffect(() => {
    setVariants([]);
    setProducts([]);
  }, [type]);
  const onSelectVariantClick = () => {
    NiceModal.show("adminCheckSelect", {
      title: "옵션 선택",
      code: "variants",
      request: (...props) => adminRequester.getVariants(...props),
      onSelect: (result) =>
        setVariants([
          ...variants,
          ...result.filter((f) => !variants.some((v) => v.id === f.id)),
        ]),
      headers: [
        {
          code: "thumbnail",
          label: "썸네일",
          type: "image",
          width: "60px",
        },
        { code: "id", label: "옵션ID" },
        { code: "title", label: "옵션명" },
      ],
      Select: Select,
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          style={{
            outline: "none",
            backgroundColor: "rgb(233, 233, 233)",
            borderRadius: "10px",
            marginLeft: "auto",
            paddingRight: "10px",
            paddingLeft: "10px",
            minWidth: "250px",
          }}
          placeholder="search..."
        />
      ),
    });
  };
  const onSelectProductClick = () => {
    NiceModal.show("adminCheckSelect", {
      title: "상품 선택",
      request: (...props) => adminRequester.getProducts(...props),
      code: "products",
      onSelect: (result) =>
        setProducts([
          ...products,
          ...result.filter((f) => !products.some((p) => p.id === f.id)),
        ]),
      headers: [
        {
          code: "thumbnail",
          label: "썸네일",
          type: "image",
          width: "60px",
        },
        { code: "id", label: "상품ID" },
        { code: "title", label: "제목" },
      ],
      Select: Select,
      Search: ({ callback }) => (
        <input
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") callback({ t: e.target.value });
          }}
          className={style.input}
          placeholder="search..."
        />
      ),
    });
  };

  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };

  const onRegClick = async () => {
    if (products.length > 0 || variants.length > 0) {
      if (inputs.current[0].getValue().length > 0) {
        let data = {};
        const title = inputs.current[0].getValue();
        if (type === "discount") {
          const value = inputs.current[1].getValue();
          if (value <= 0 || value > 100) {
            toast.error("할인율은 0이상 100 이하의 숫자이어야합니다", {
              autoClose: 1000,
              position: toast.POSITION.BOTTOM_CENTER,
            });
          } else {
            data.regions = (await adminRequester.getRegions()).regions.map(
              (region) => region.id
            );
            data.code = `${new Date().getTime()}_${title}`;
            data.is_dynamic = false;
            data.is_disabled = false;
            data.starts_at = dateRef.current.getStartDate();
            data.ends_at = dateRef.current.getEndDate();
            data.rule = {
              type: "percentage",
              value: value,
              allocation: "total",
              // conditions: [
              //   {
              //     // type: "products",
              //     operator: "in",
              //     products: products?.map((product) => product.id),
              //   },
              //   {
              //     // type: "variants",
              //     operator: "in",
              //     variants: variants?.map((variant) => variant.id),
              //   },
              // ],
            };
            adminRequester.postDiscount(data, (result) => {
              const discount = result.discount;
              const conditions = [];
              if (products?.length > 0)
                conditions.push({
                  type: "products",
                  operator: "in",
                  products: products?.map((product) => product.id),
                });
              if (variants?.length > 0)
                conditions.push({
                  type: "variants",
                  operator: "in",
                  variants: variants?.map((variant) => variant.id),
                });

              adminRequester.updateDiscount(
                discount.id,
                {
                  title: title,
                  rule: {
                    ...discount.rule,
                    conditions: conditions,
                  },
                },
                () => navigate("/admin/promotionManagement")
              );
            });
          }
        } else if (type === "event") {
          if (mixYn === undefined) {
            toast.error("교차선택 가능여부를 선택해주세요", {
              autoClose: 1000,
              position: toast.POSITION.BOTTOM_CENTER,
            });
          } else {
            const N = inputs.current[2].getValue();
            const M = inputs.current[3].getValue();
            if (N === 0 || M === 0) {
              toast.error("증정 기준을 설정해주세요", {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
              });
            } else {
              data.title = title;
              data.cross = mixYn;
              data.handle = `${new Date().getTime()}_${data.title}`;
              data.N = N;
              data.M = M;
              data.start_date = dateRef.current.getStartDate();
              data.end_date = dateRef.current.getEndDate();
              data.products = products.map((select) => select.id);
              adminRequester.postEvent(data, () =>
                navigate("/admin/promotionManagement")
              );
            }
          }
        } else {
          toast.error("타입을 선택해주세요", {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } else {
        toast.error("제목을 입력해주세요", {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } else {
      toast.error("대상을 선택해주세요", {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  return (
    <VerticalFlex gap={20}>
      <FlexChild>
        <HorizontalFlex gap={40}>
          <FlexChild width={"15%"}>
            <P>제목</P>
          </FlexChild>
          <FlexChild>
            <InputText ref={(el) => (inputs.current[0] = el)} />
          </FlexChild>
        </HorizontalFlex>
      </FlexChild>
      <FlexChild>
        <HorizontalFlex gap={40}>
          <FlexChild width={"15%"}>
            <P>타입</P>
          </FlexChild>
          <FlexChild width={300}>
            <RadioGroup
              name="example"
              value={type}
              onChange={(e) => {
                setType(e);
              }}
            >
              <RadioChildren value={"discount"}>할인</RadioChildren>
              <RadioChildren value={"event"}>증정</RadioChildren>
            </RadioGroup>
          </FlexChild>
          <FlexChild />
        </HorizontalFlex>
      </FlexChild>
      <FlexChild>
        <HorizontalFlex gap={40}>
          <FlexChild width={"15%"}>
            <P>적용 상품</P>
          </FlexChild>
          <FlexChild>
            <HorizontalFlex gap={10} alignItems={"flex-start"}>
              <FlexChild>
                <FlexGrid columns={4}>
                  {products.map((select) => (
                    <FlexChild>
                      <HorizontalFlex>
                        <FlexChild width="30px" marginRight={"10px"}>
                          <ToolTip
                            zIndex={10}
                            left={"30px"}
                            title={
                              <img
                                style={{
                                  maxWidth: "25vw",
                                  maxHeight: "25vh",
                                  height: "25vh",
                                }}
                                src={select.thumbnail}
                                alt="t"
                              />
                            }
                          >
                            <img
                              src={select.thumbnail}
                              alt="t"
                              height={"30px"}
                              width={"30px"}
                            />
                          </ToolTip>
                        </FlexChild>
                        <FlexChild>
                          <P>{select.title}</P>
                        </FlexChild>
                        <FlexChild marginLeft={"10px"}>
                          <button
                            onClick={() =>
                              setProducts([
                                ...products.filter((f) => f.id !== select.id),
                              ])
                            }
                          >
                            x
                          </button>
                        </FlexChild>
                      </HorizontalFlex>
                    </FlexChild>
                  ))}
                </FlexGrid>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <CustomButton
                  text={"추가"}
                  style={initializationStyle}
                  onClick={onSelectProductClick}
                />
              </FlexChild>
            </HorizontalFlex>
          </FlexChild>
        </HorizontalFlex>
      </FlexChild>
      {type && type === "discount" && (
        <FlexChild>
          <HorizontalFlex gap={40}>
            <FlexChild width={"15%"}>
              <P>적용 옵션</P>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10} alignItems={"flex-start"}>
                <FlexChild>
                  <FlexGrid columns={4}>
                    {variants.map((select) => (
                      <FlexChild>
                        <HorizontalFlex>
                          <FlexChild width="30px" marginRight={"10px"}>
                            <ToolTip
                              zIndex={10}
                              left={"30px"}
                              title={
                                <img
                                  style={{
                                    maxWidth: "25vw",
                                    maxHeight: "25vh",
                                    height: "25vh",
                                  }}
                                  src={select.thumbnail}
                                  alt="t"
                                />
                              }
                            >
                              <img
                                src={select.thumbnail}
                                alt="t"
                                height={"30px"}
                                width={"30px"}
                              />
                            </ToolTip>
                          </FlexChild>
                          <FlexChild>
                            <P>{select.title}</P>
                          </FlexChild>
                          <FlexChild marginLeft={"10px"}>
                            <button
                              onClick={() =>
                                setVariants([
                                  ...variants.filter((f) => f.id !== select.id),
                                ])
                              }
                            >
                              x
                            </button>
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                    ))}
                  </FlexGrid>
                </FlexChild>
                <FlexChild width={"max-content"}>
                  <CustomButton
                    text={"추가"}
                    style={initializationStyle}
                    onClick={onSelectVariantClick}
                  />
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      )}
      {type && type === "discount" && (
        <FlexChild>
          <HorizontalFlex gap={40}>
            <FlexChild width={"15%"}>
              <P>할인율</P>
            </FlexChild>
            <FlexChild width={200}>
              <InputNumber
                ref={(el) => (inputs.current[1] = el)}
                min={0}
                max={100}
              />
            </FlexChild>
            <FlexChild />
          </HorizontalFlex>
        </FlexChild>
      )}
      {type && type === "event" && (
        <FlexChild>
          <HorizontalFlex gap={40}>
            <FlexChild width={"15%"}>
              <P>증정 기준</P>
            </FlexChild>
            <FlexChild width={200}>
              <InputNumber ref={(el) => (inputs.current[2] = el)} />
            </FlexChild>
            <FlexChild width={"initial"}>
              <P>+</P>
            </FlexChild>
            <FlexChild width={200}>
              <InputNumber ref={(el) => (inputs.current[3] = el)} />
            </FlexChild>
            <FlexChild />
          </HorizontalFlex>
        </FlexChild>
      )}
      {type && type === "event" && (
        <FlexChild>
          <HorizontalFlex gap={40}>
            <FlexChild width={"15%"}>
              <P>교차선택</P>
            </FlexChild>
            <FlexChild width={300}>
              <RadioGroup
                name="example"
                value={mixYn}
                onChange={(e) => {
                  setMixYn(e);
                }}
              >
                <RadioChildren value={true}>허용</RadioChildren>
                <RadioChildren value={false}>불가</RadioChildren>
              </RadioGroup>
            </FlexChild>
            <FlexChild />
          </HorizontalFlex>
        </FlexChild>
      )}
      <FlexChild>
        <HorizontalFlex gap={40}>
          <FlexChild width={"15%"}>
            <P>기간</P>
          </FlexChild>
          <FlexChild width={"initial"}>
            <DatePicker
              ref={dateRef}
              maxDate={maxDate}
              type={"time"}
              startDate={startDate}
              endDate={endDate}
            />
          </FlexChild>
          <FlexChild></FlexChild>
        </HorizontalFlex>
      </FlexChild>
      <FlexChild>
        <CustomButton text={"등록"} onClick={onRegClick} />
      </FlexChild>
    </VerticalFlex>
  );
}
const Select = ({ callback }) => {
  const [stores, setStores] = useState([]);
  useEffect(() => {
    adminRequester.getStores({}, ({ stores }) => setStores(stores));
  }, []);
  return (
    <select
      onChange={(e) => {
        if (e.target.value === "전체") callback({ s: null });
        else callback({ s: e.target.value });
      }}
      style={{
        outline: "none",
        backgroundColor: "rgb(233, 233, 233)",
        borderRadius: "10px",
        marginRight: "auto",
        paddingRight: "10px",
        paddingLeft: "10px",
        minWidth: "250px",
      }}
    >
      <option>전체</option>
      {stores.map((store) => (
        <option value={store.id} key={store?.id}>
          {store.name}
        </option>
      ))}
    </select>
  );
};
export default PromotionRegisterDetail;
